import "./Contact.module.css";
import NavegacionPrincipal from "@/reusable_sections/Header";
import AccessRequest from "./sections/AccessRequest";
import AsNossasLojasFisicas from "./sections/AsNossasLojasFisicas";
import FaqSection from "./sections/FaqSection";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NavegacionPrincipal />
      <AccessRequest />
      <AsNossasLojasFisicas />
      <FaqSection />
      <Footer />
    </div>;
}